import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import React from "react";
import { useReceiptService } from "serviceHooks";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";

function useReceiptDraftSuppliers() {
  const receiptService = useReceiptService();

  const [topWintCardSuppliers, setTopWintCardSuppliers] = React.useState<AutocompleteListItem[]>([]);

  const searchSupplier = async (value: string) => {
    if (value)
      return receiptService.searchWintCardSuppliers(value).then((res) => {
        const options: AutocompleteListItem[] = res.map((s, index) => ({
          id: index,
          value: s,
          group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
        }));
        return options;
      });

    return [];
  };

  React.useEffect(() => {
    receiptService.getTopWintCardSuppliers().then((res) => {
      setTopWintCardSuppliers(
        res?.map((item, index) => ({
          id: index,
          value: item,
          group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
        })) ?? []
      );
    });
  }, []);

  return {
    topWintCardSuppliers,
    searchSupplier,
  };
}

export default useReceiptDraftSuppliers;
